import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { enableProdMode, ErrorHandler, importProvidersFrom, inject } from '@angular/core';
import { environment } from './environments/environment';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { LogLevel, MIN_LOG_LEVEL } from './app/core/services/utils/logger.service';
import { RouteReuseStrategy, provideRouter, withNavigationErrorHandler } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';
import { routes } from './app/app.routes';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { getAnalytics, provideAnalytics } from '@angular/fire/analytics';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { CUSTOM_DATE_FORMATS } from './app/shared/adapters/date.adapter';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor } from './app/shared/interceptors/auth.interceptor';
import { logsConnectivityInterceptor } from './app/shared/interceptors/logs-connectivity.interceptor';
import { LogsErrorHandler } from './app/core/services/logs-error-handler';
import { monitoringScopeInterceptor } from './app/shared/interceptors/monitoring-scope.interceptor';
import { LazyRouteRecoveryService } from './app/core/services/lazy-route-recovery.service';

if (environment.production) {
  enableProdMode();
}

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: ErrorHandler, useClass: LogsErrorHandler },
    {
      provide: MIN_LOG_LEVEL,
      useValue: LogLevel.DEBUG//isDevMode() ? LogLevel.INFO : LogLevel.NEVER,
    },
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    },
    provideRouter(routes, withNavigationErrorHandler(event => {
      inject(LazyRouteRecoveryService).recover(event);
    })),
    provideHttpClient(withInterceptors([monitoringScopeInterceptor, authInterceptor, logsConnectivityInterceptor])),
    // Import Providers
    importProvidersFrom(
      // Ngx Translate
      TranslateModule.forRoot({
        defaultLanguage: 'it',
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      }),
    ),
    provideIonicAngular({
      innerHTMLTemplatesEnabled: true // Add here
    }),
    provideAnalytics(() => getAnalytics()),
    provideMessaging(() => getMessaging()),
    provideMomentDateAdapter(CUSTOM_DATE_FORMATS),
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
    provideAnimations()
  ],
}).catch((err) => console.error(err));
